export default {"src":"/_next/static/media/caminho-pink.98c97891.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};